import React from 'react';
import { EXISTING_SITE_ANALYSIS, PROGRAMMING } from 'spw-constants';
import { ProjectType } from 'spw-redux/modules/projects/types';
import { colors } from 'spw-theme';
import styled from 'styled-components';

const Container = styled.div`
  border-radius: 12px;
  font-weight: 400;
  font-size: 12px;
  line-height: 15.5px;
  color: ${colors.black};
  background: ${colors.mainGreenLight};
  padding: 4px 8px;
  height: 24px;
  box-sizing: border-box;
  font-family: 'Roboto';
`;

const colorsForProjectType: Record<ProjectType, React.CSSProperties> = {
  [PROGRAMMING]: {
    backgroundColor: colors.backgroundGrey,
    border: `1px solid ${colors.veryLightGray}`,
  },
  [EXISTING_SITE_ANALYSIS]: {
    backgroundColor: colors.white,
    border: `1px solid ${colors.veryLightGray}`,
  },
};

type Props = {
  projectType: ProjectType;
  className?: string;
};

const ProjectTypeTag = ({ projectType, className }: Props) => {
  return (
    <Container className={className} style={colorsForProjectType[projectType]}>
      {projectType === 'programming' ? 'PROG' : 'ESA'}
    </Container>
  );
};

export default ProjectTypeTag;
